module.exports = __webpack_public_path__ + "assets/icons/delete-24px.svg";